// Fuente unica de la URL base del API.
//
// - Produccion (npm run build / deploy SWA): usa la URL de Azure por default.
// - Local (npm start): si existe la variable REACT_APP_API_BASE definida en
//   frontend/.env.development.local, apunta ahi (p.ej. http://localhost:7071/api).
//
// Las variables REACT_APP_* las inyecta Create React App en build/start; cambiarlas
// requiere reiniciar el servidor de desarrollo.
export const API = process.env.REACT_APP_API_BASE
  || 'https://jya-sistema-api.azurewebsites.net/api';
